import {browserHistory} from 'react-router';

import api from 'api';
import * as types from '../../../redux/actionTypes';

import { SUBSCRIPTION_ERROR } from '../../../utils/logger/logTypes';
import { isTenantId } from '@a0/support-center-common/lib/tenants';

function loadTenantAgreementsBegin() {
  return { type: types.LOAD_TENANT_AGREEMENTS_BEGIN};
}

function loadTenantAgreementsSuccess(records) {
  return { type: types.LOAD_TENANT_AGREEMENTS_SUCCESS, records};
}

export function loadTenantAgreementsError(error) {
  return { type: types.LOAD_TENANT_AGREEMENTS_ERROR, error, log_type: SUBSCRIPTION_ERROR };
}
function loadTenantAgreementsIds(custom_agreements) {
  return { type: types.LOAD_TENANT_AGREEMENTS_IDS_FOR_USER, custom_agreements};
}

export function setSelectedAgreement(tenant) {
  return { type: types.SET_SELECTED_AGREEMENT, tenant};
}

export function loadTenantAgreementsForUser(userId, options) {
  return function(dispatch, getState) {
    dispatch(loadTenantAgreementsBegin());

    return api.tenants.getTenantsAgreement(userId, options, true)
    .then(agreements => {
      const normalizedData = {};
      const agreementIds = [];

      agreements.forEach(agreement => {
        // log customer account id if no master tenant
        if (agreement.customer_account_id && !isTenantId(agreement.customer_account_id)) {
          normalizedData[agreement.customer_account_id] = agreement;
          agreementIds.push(agreement.customer_account_id);
        } else {
          normalizedData[agreement.tenant] = agreement;
          agreementIds.push(agreement.tenant);
        }
      });

      dispatch(loadTenantAgreementsIds(agreementIds));
      dispatch(loadTenantAgreementsSuccess(normalizedData));
    }).catch(error => {
      dispatch(loadTenantAgreementsError(error));
    });
  };
}
